document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict(),
		d = new Date(),
		n = d.getFullYear(),
		page = $('html, body'),
		i = 0;

	function onScroll() {

		if ($(window).scrollTop() > 70) {
			$('.scroll-up').removeClass('hidden');
		} else {
			$('.scroll-up').addClass('hidden');
		}
	}
	window.addEventListener('scroll', onScroll, false);

	setTimeout(function() {
		$('.seo-pop-form-link').trigger('click');
	}, 20000);

	$('.foo-copy s').text(n).addClass('foo-copy-year');

	$('.wpcf7-acceptance .wpcf7-list-item').append('<i></i>');

	$('.accordion-button').addClass('collapsed');

	$('.wpcf7-select').select2({
		placeholder: "Please select",
		minimumResultsForSearch: 3,
    	allowClear: true
	});

	$(".foo-copy .widget_text p strong").text(n);

	$('.h-icons .search-h').on( "click", function() {
		$('.h-icons .wp-block-search').toggleClass('active');
	});

	$('.h-icons .soc-h').on( "click", function() {
		$('.h-icons .wp-block-social-links').toggleClass('active');
	});

	$('.wp-block-navigation__responsive-container-open').html( "<i></i><i></i><i></i>");

	$('.wp-block-navigation__responsive-container-open').on('click', function() {	
		$(this).toggleClass('close');
		setTimeout(function() {
			$('.has-modal-open.is-menu-open').toggle();
		}, 500);
	});

	$('.scroll-up').click(function(e) {
		page.animate({
			scrollTop : 0,
		}, 100);
		e.preventDefault();
	});

	$('.scroll-down').click(function(e) {
		var SlideHeight = $('.section__intro-home').height();
		// /console.log(SlideHeight);
		page.animate({
			scrollTop : page.scrollTop() + SlideHeight,
		}, 100);
		e.preventDefault();
	});

	// Mega Menu for LG (responsive large tablet & up)
	var win = $(window);

	if (win.width() > 1200) {
		$('.wp-block-navigation__responsive-container-content').prepend('<input class="hm-input" type="checkbox"><div id="menu-hm"></div>');		
	} else {
		$('.wp-block-navigation__submenu-icon + .wp-block-navigation-submenu').hide();
	}
	
	function setCookie(name, value, expiry) {
		let d = new Date();
		d.setTime(d.getTime() + (expiry*86400000));
		document.cookie = name + "=" + value + ";" + "expires=" + d.toUTCString() + ";path=/";
	}
	
	function getCookie(name) {
		let cookie = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
		return cookie ? cookie[2] : null;
	}
	
	function eatCookie(name) {
		setCookie(name, "", -1);
	}

	$('.hm-input').click(function() {
		$('.cookie-nav-open').toggleClass('cookie-nav-close');
	});

	$('#menu-hm, .hm-input').click(function() {
		setCookie('nav-cookie','cookie-nav-open','360');
		$('.wp-block-navigation__responsive-container-content').addClass('cookie-nav-open');
	});

	if( getCookie('nav-cookie') == 'cookie-nav-open' ) {
		$('.wp-block-navigation__responsive-container-content').addClass('cookie-nav-open');
		$('.hm-input').prop('checked', true);
	} else {
		$('.wp-block-navigation__responsive-container-content').removeClass('cookie-nav-open');
	}

	var id = $('.section__tabs--content').attr('id');
	$('.section__tabs ul.nav li').removeClass('active');
	$('.section__tabs ul.nav li').each(function() {
		i++;
		$(this).addClass('tab-id-' + i);
		$(this).children('a').attr('data-tab','#tab-id-' + i);
		var cl = $(this).attr('class');		
		if ( $(this).hasClass(id) ) {
			$(this).addClass('active');
			//console.log(id);
		}
	});
	
	$(window).scroll(function() {

        if($(this).scrollTop() > 70){
			$('.site-header').addClass('bg-header');
            $('.wp-block-site-logo').addClass('logo-header');
			$('.wp-block-post-title').addClass('scrolling-title');
        } else {
			$('.site-header').removeClass('bg-header');
            $('.wp-block-site-logo').removeClass('logo-header');
			$('.wp-block-post-title').removeClass('scrolling-title');
        }
    });

	if ( window.location.pathname == '/connect/' ) {
		$('.block__contact').addClass('bc-hide');
	} else {
		$('.block__contact').removeClass('bg-hide');
	}

	$('.taxonomy-post_tag.wp-block-post-terms a, .single .wp-block-tag-cloud a').each(function() {
		var text = $(this).text();
		$(this).replaceWith($('<span />').text(text));
	});

});
